import { GET_APAS } from '../../graphql/user/query';
import { Apas, ApasVariables } from '../../graphql/user/types/Apas';
import { useQuery } from '@apollo/react-hooks';

export const useGetApas = () => {
  return useQuery<Apas, ApasVariables>(GET_APAS, {
    fetchPolicy: 'network-only',
  });
};
